<template>
    <b-modal ref="modal"
             :cancel-variant="data.cancelVariant || undefined"
             :header-bg-variant="data.headerBgVariant || undefined"
             :footer-bg-variant="data.footerBgVariant || undefined"
             :header-text-variant="data.headerTextVariant || undefined"
             :size="data.size || 'md'" :centered="data.centered || false"
             :scrollable="data.scrollable || false"
             :no-close-on-backdrop="data.noCloseOnBackdrop || false"
             :no-close-on-esc="data.noCloseOnEsc || false"
             :title-html="data.title" :ok-only="true"
             :ok-title="data.okTitle || _trans('Ok')"
             @hide="hide"
             @hidden="onClose"
             @shown="onShow"
             @ok="close(1)"
    >
        <template slot="modal-header-close">
            <b-button class="ni ni-close" size="sm" variant="primary" @click="close()"></b-button>
        </template>
        <p class="my-4" :class="{ 'text-center': data.textCenter }" v-html="data.body"></p>
    </b-modal>
</template>

<script>
    import { bus } from "@store/dau";
    export default {
        data() {
            return {
                response: {},
                data: {}
            };
        },
        mounted() {
            this.onMounted();
        },
        beforeDestroy() {
            this.$refs.modal.$root.$off("bv::modal::shown");
            this.$refs.modal.$root.$off("bv::modal::show");
            this.$refs.modal.$root.$off("bv::modal::hide");
            this.$refs.modal.$root.$off("bv::modal::hidden");
        },
        methods: {
            onMounted() {
                this.$refs.modal.$root.$on("bv::modal::shown", (event, modalId) => {
                    bus.$emit("bv::modal::shown", event, modalId);
                });
                this.$refs.modal.$root.$on("bv::modal::show", (event, modalId) => {
                    bus.$emit("bv::modal::show", event, modalId);
                });
                this.$refs.modal.$root.$on("bv::modal::hide", (event, modalId) => {
                    bus.$emit("bv::modal::hide", event, modalId);
                });
                this.$refs.modal.$root.$on("bv::modal::hidden", (event, modalId) => {
                    bus.$emit("bv::modal::hidden", event, modalId);
                });
            },
            onShow() {},
            onClose() {},
            hide(e) {
                if (e && ["esc", "backdrop", "headerclose"].indexOf(e.trigger) > -1) {
                    let mode = -1;
                    this.$emit("close", mode, this.response);
                }
            },
            close(mode = -1) {
                this.$refs.modal.hide();
                this.$emit("close", mode, this.response);
            },
            open(data = { title: "Title", body: "<p>Message</p>" }) {
                this.data = data;
                this.$refs.modal.show();

                // Return object to handle event in one line
                return this;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modal.vue